import { OwnedAssistanceProduct } from '@/interfaces';
import { RSA_ROADSIDE_EXCESS_USE, RoadsideProductType, } from '../roadside-helpers';

const allExceptCmoAndExcess = (policy: OwnedAssistanceProduct): boolean => {
  return (
    !!policy && policy.roadsidePolicyType !== RoadsideProductType.Cmo && policy.productCode !== RSA_ROADSIDE_EXCESS_USE
  );
};

export const RSAFirstLinkRules = {
  allExceptCmoAndExcess,
};
